import { DoorLoopLoader } from "components/loader/doorloopLoader";
import { ReactComponent as CalendarLoaderIcon } from "@/icons/svg/calendar-loader.svg";
import { ReactComponent as CalendarLoaderMobileIcon } from "@/icons/svg/mobile-calendar-loader.svg";
import { useResponsiveHelper } from "contexts/responsiveContext";

interface ScheduleLoaderProps {
  showLoader: boolean;
}

export const ScheduleLoader = ({ showLoader }: ScheduleLoaderProps) => {
  const { isMobile } = useResponsiveHelper();

  if (!showLoader) {
    return null;
  }

  return (
    <div className="relative h-[30px]">
      <div className={`mt-[3%] flex w-full items-center justify-center md:mt-[10%]`}>
        <div className="relative z-10 flex w-4/5 flex-col items-center justify-center gap-4">
          <DoorLoopLoader />
          <div className="text-2xl font-black">Just a moment...</div>
          <div className="text-center text-xl font-semibold">We're finding the best time for your demo</div>
        </div>
      </div>
      {isMobile ? (
        <CalendarLoaderMobileIcon className="absolute -top-[80px] left-1/2 h-auto w-full max-w-[360px] -translate-x-1/2 overflow-hidden opacity-10" />
      ) : (
        <CalendarLoaderIcon className="absolute left-1/2 h-auto -translate-x-1/2 overflow-hidden md:-top-[200px] md:w-[600px]" />
      )}
    </div>
  );
};
